/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */

import { useState, useEffect, useRef, useMemo } from "react";
import { Badge, Button, Input } from "@repo/ui";
import { Link } from "react-router-dom";
import { CirclePlus, CircleX } from "lucide-react";
import { Paths } from "routes/paths";
import { HasPermission } from "utils/helper";
import { useUser } from "hooks/use-user";

export default function FilterBarV2({ getList }) {
  const [filters, setFilters] = useState({});

  const [filter, setFilter] = useState(null);
  const filterTimeout = useRef(null);
  const user = useUser();

  useEffect(() => {
    if (filter !== null) {
      filterTimeout.current = setTimeout(() => {
        getList(filter || "", new Date(), "", "");
        handleAddFilter("filter", filter, "Search");
        clearTimeout(filterTimeout.current);
        filterTimeout.current = null;
      }, 1000);
    }
    return () => {
      if (filterTimeout.current) {
        clearTimeout(filterTimeout.current);
        filterTimeout.current = null;
      }
    };
  }, [filter]);

  const handleClearFilter = (key) => {
    const updatedFilter = { ...filters };
    delete updatedFilter[key];
    if (key === "filter") {
      setFilter("");
    }
    setFilters({ ...updatedFilter });
  };
  const handleAddFilter = (key, value, name) => {
    if (value === "") {
      handleClearFilter(key);
      return;
    }
    const updatedFilter = { ...filters };

    updatedFilter[key] = `${name}: ${value}`;
    setFilters({ ...updatedFilter });
  };
  const clearAllFilters = () => {
    setFilters({});
    setFilter("");
  };

  const canAdd = useMemo(() => {
    return HasPermission(user, "CashCenter", "Add");
  }, [user]);
  return (
    <>
      <div className="flex mb-3 gap-1">
        <div className="w-full">
          <Input
            value={filter}
            placeholder="Search"
            title="Search"
            onChange={(e) => {
              setFilter(e.target.value);
            }}
          />
        </div>
        {canAdd ? (
          <Button
            variant="secondary"
            className="flex-1 flex flex-row justify-end gap-0"
            style={{ padding: 0 }}
          >
            <Link to={Paths.addCashCenter}>
              <Button variant="secondary" className="flex flex-row gap-2">
                <CirclePlus />
                Create Cash Center
              </Button>
            </Link>
          </Button>
        ) : (
          <></>
        )}
      </div>
      <div className="flex mb-3 gap-2 flex-wrap items-end">
        {Object.entries(filters).map(([key, value]) => (
          <Badge
            variant="secondary"
            className="gap-3 pr-1 cursor-pointer"
            key={key}
          >
            {value}
            <CircleX
              onClick={() => {
                handleClearFilter(key);
              }}
            />
          </Badge>
        ))}
        {Object.keys(filters).length > 0 ? (
          <Badge variant="secondary" className="gap-3 pr-1 cursor-pointer">
            Clear All
            <CircleX
              onClick={() => {
                clearAllFilters();
              }}
            />
          </Badge>
        ) : (
          <></>
        )}
      </div>
    </>
  );
}
